import React, { useEffect, useState } from 'react';
import { Box, Tabs, Tab, Divider, Paper, Typography, IconButton, InputAdornment } from '@mui/material';
import PrincipalDashboard from './PrincipalDashboard';
import TeacherDashboard from './TeacherDashboard';
import Header from './Header';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

const MainSectionSchool = ({ LessonPlannerComponent }) => {
  const [tab, setTab] = useState(0);
  const [role, setRole] = useState('admin'); // default
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    // Get role from localStorage (stored separately now)
    const storedRole = localStorage.getItem('role');
    if (storedRole) {
      const normalizedRole = storedRole.toUpperCase();
      if (normalizedRole === 'ROLE_ADMIN') setRole('admin');
      else if (normalizedRole === 'ROLE_TEACHER') setRole('teacher');
      else setRole('teacher'); // fallback
    }
  }, []);

  // Only show Lesson Planner tab for allowed roles
  const showLessonPlanner = role === 'admin' || role === 'teacher';

  // Tab labels based on role
  const tabLabels = [
    role === 'admin' ? 'My Dashboard' : 'My Dashboard',
    ...(showLessonPlanner ? ['Lesson Planner'] : []),
  ];

  // Password visibility toggle handler
  const handleTogglePassword = () => setShowPassword((prev) => !prev);

  return (
    <Box
      sx={{
        width: '100%',
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #e3f2fd 0%, #fce4ec 100%)',
      }}
    >
      <Header />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'flex-start',
          py: 6,
        }}
      >
        <Paper
          elevation={6}
          sx={{
            width: '100%',
            maxWidth: 950,
            p: 4,
            borderRadius: 4,
            boxShadow: 6,
            background: 'white',
          }}
        >
          <Typography
            variant="h4"
            sx={{
              mb: 3,
              fontWeight: 'bold',
              color: '#1976d2',
              textAlign: 'center',
              letterSpacing: 1,
            }}
          >
            {role === 'admin' ? 'Admin Section' : 'Employee Section'}
          </Typography>
          <Tabs
            value={tab}
            onChange={(_, v) => setTab(v)}
            centered
            sx={{
              mb: 2,
              '& .MuiTab-root': {
                fontWeight: 600,
                fontSize: '1.1rem',
                letterSpacing: 0.5,
              },
              '& .Mui-selected': {
                color: '#1976d2 !important',
              },
              '& .MuiTabs-indicator': {
                backgroundColor: '#1976d2',
                height: 4,
                borderRadius: 2,
              },
            }}
          >
            {tabLabels.map((label, idx) => (
              <Tab key={label} label={label} />
            ))}
          </Tabs>
          <Divider sx={{ mb: 3 }} />
          {tab === 0 && (
            <Box sx={{ minHeight: 400 }}>
              {role === 'admin' ? <PrincipalDashboard /> : <TeacherDashboard />}
            </Box>
          )}
          {tab === 1 && showLessonPlanner && LessonPlannerComponent && (
            <Box sx={{ minHeight: 400 }}>
              <LessonPlannerComponent
                showPassword={showPassword}
                passwordAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleTogglePassword}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </Box>
          )}
        </Paper>
      </Box>
    </Box>
  );
};

export default MainSectionSchool;